import { Html5Qrcode } from "html5-qrcode";

document.addEventListener('alpine:init', () => {
    Alpine.data('codeScanner', () => ({
        scanner: null,

        startObserver() {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.initScanner();
                    } else {
                        this.stopScanner();
                    }
                });
            }, { threshold: 0.1 });

            observer.observe(this.$el);
        },

        initScanner() {
            this.scanner = new Html5Qrcode(this.$refs.codeScannerVideo.id);

            let selectInput = this.$refs.cameraSelect;
            selectInput.innerHTML = '';

            Html5Qrcode.getCameras().then(devices => {
                if (devices && devices.length) {
                    devices.forEach(device => {
                        let option = document.createElement('option');
                        option.value = device.id;
                        option.textContent = device.label;
                        selectInput.appendChild(option);
                    });

                    this.startScanner();
                } else {
                    let option = document.createElement('option');
                    option.value = '';
                    option.textContent = selectInput.getAttribute('data-no-camera-label');
                    selectInput.appendChild(option);
                }
            }).catch(err => {
                console.error('Failed to get devices: ' + err);

                let option = document.createElement('option');
                option.value = '';
                option.textContent = selectInput.getAttribute('data-no-camera-label');
                selectInput.appendChild(option);
            });
        },

        reinitScanner() {
            if (this.scanner) {
                if (this.scanner.isScanning) {
                    this.scanner.stop().then(() => {
                        this.startScanner();
                    }).catch(err => {
                        console.error('Failed to stop scanner: ' + err);
                    });
                } else {
                    this.startScanner();
                }
            }
        },

        stopScanner() {
            if (this.scanner && this.scanner.isScanning) {
                this.scanner.stop().catch(err => {
                    console.error('Failed to stop scanner: ' + err);
                });
            }
        },

        startScanner() {
            let selectedCameraId = this.$refs.cameraSelect.value;
            let config = { fps: 30 };

            if (selectedCameraId && this.scanner) {
                this.scanner.start(
                    { deviceId: { exact: selectedCameraId } },
                    config,
                    (decodedText, decodedResult) => {
                        this.$refs.codeScannerContainer.classList.add('ring-2');
                        this.state = decodedText;
                    },
                    () => {
                        this.$refs.codeScannerContainer.classList.remove('ring-2');
                    }
                ).catch(err => {
                    console.error('Failed to start scanner: ' + err);
                });
            }
        }
    }));
});
